import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import { RouteContext } from '../../context';
import {
  BlackHeadings,
  HoverNonBorderTableEditableItemBackground,
  HoverBackground,
} from '../../theme/colors';
import ColorUtils from '../../utils/ColorUtils';

export const useSidebarTheme = () => {
  const theme = useTheme();
  const { pathname } = React.useContext(RouteContext);
  const sidebarTheme = React.useMemo(() => {
    if (pathname.includes('/settings')) {
      return {
        itemTextColor: BlackHeadings,
        itemBackground: HoverBackground,
        itemHoverBackground: HoverNonBorderTableEditableItemBackground,
      };
    }

    return {
      itemTextColor: theme.palette.primary.contrastText,
      itemBackground: theme.palette.primary.main,
      itemHoverBackground: ColorUtils.GetColorDarknessShades(
        theme.palette.primary.main,
      ).midDark,
    };
  }, [pathname]);

  return { sidebarTheme };
};
